import { render, staticRenderFns } from "./Leef.vue?vue&type=template&id=220bff1f&"
import script from "./Leef.vue?vue&type=script&lang=js&"
export * from "./Leef.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports